<template>
  <Layout :footer-style="2" header-class="header-left-align" nav-alignment="right" :header-transparency="false" :show-top-header="true" buy-button-class="btn-default btn-small">

    <div class="rwt-split-area rn-section-gap">
      <div class="wrapper">
        <div class="row">
          <div class="col-lg-12 mb--40">
            <SectionTitle
                subtitle="YAO XIE GONG MAO"
                text-align="center"
                title="资质证书"
                data-aos="fade-up"
            />
          </div>
        </div>
        <Swiper :clist="clist"></Swiper>
      </div>
    </div>

    <div  style="width: 100%" >

      <CallToAction
          :style-type="9"
          title="权威机构认证，品质保证，值得信赖!"
          btn-text="联系我们"
      />


    </div>



  </Layout>
</template>

<script>

import CallToAction from "@/components/elements/callToAction/CallToAction";
import SectionTitle from "../../components/elements/sectionTitle/SectionTitle";
import Layout from "../../components/common/Layout";
import Swiper from "../../components/elements/swiper/Swiper";
export default {
  name: "AboutQualifications",
  components: {SectionTitle,Layout,Swiper,CallToAction},
  //页面引入vue-awesome-swiper 及其样式
  data(){
    return{
      queryParams: {
        navId: this.$route.query.id,
      },
      clist: [
        {
          src: undefined
        },
        {
          src: undefined
        },
        {
          src: undefined
        },
        {
          src: undefined
        }
        ,
        {
          src: undefined
        }
      ],
    }
  },
  created() {
    this.getProduct(this.queryParams);
  },
  methods:{
    getProduct(data){
      this.getRequest("/system/web/product",data).then(resp=>{
        let galleryList = []
        resp.data.rows.forEach(item =>{
          var fileUrl = item.url;
          let data={
            src: process.env.VUE_APP_BASE_API+fileUrl,
          }
          galleryList.push(data)
        })
        this.clist = galleryList;


      })
    },

  }


}
</script>

<style scoped>

</style>